import { DATABASE_DETAIL_TYPE } from '@/database/adapter/openDetail.define';
import {
  instanceDetailSchema,
  shardedClusterDetailSchema,
  clusterDetailSchema,
  type ClusterDetailSchema,
  type InstanceDetailSchema,
  type ShardedClusterDetailSchema,
  type InstanceDetailAddition,
  type ShardedClusterDetailAddition,
  type ClusterDetailAddition,
} from './instance.schema';
import { formatName, mergeDetailInfo, parseSchema } from './utils';
import type { DetailParams } from '../types';
import { getRequiredMap } from '@/common/utils/core/detailFieldMeta.utils';

export const getNormalInstanceDetailAddition = ({
  detailInfo,
  fromTime,
  toTime,
  instanceId,
}: DetailParams): { name: string; instance: InstanceDetailAddition } => {
  const {
    data: { instanceName, ...rest },
  } = parseSchema<InstanceDetailSchema>(
    instanceDetailSchema,
    mergeDetailInfo(detailInfo, instanceId, { fromTime, toTime }),
    DATABASE_DETAIL_TYPE.INSTANCE,
  );
  return { name: formatName(instanceName), instance: rest };
};

export const getShardedClusterDetailAddition = ({
  detailInfo,
  fromTime,
  toTime,
  instanceId,
}: DetailParams): {
  name: string;
  instance: InstanceDetailAddition;
  addition: ShardedClusterDetailAddition;
} => {
  const {
    data: { instanceName, subType, ...rest },
  } = parseSchema<ShardedClusterDetailSchema>(
    shardedClusterDetailSchema,
    mergeDetailInfo(detailInfo, instanceId, { fromTime, toTime }),
    DATABASE_DETAIL_TYPE.SHARDED_CLUSTER,
  );
  return {
    name: formatName(instanceName),
    instance: rest,
    addition: { subType },
  };
};

export const getClusterDetailAddition = ({
  detailInfo,
  fromTime,
  toTime,
  instanceId,
}: DetailParams): { name: string; cluster: ClusterDetailAddition } => {
  const {
    data: { instanceName, ...rest },
  } = parseSchema<ClusterDetailSchema>(
    clusterDetailSchema,
    mergeDetailInfo(detailInfo, instanceId, { fromTime, toTime }),
    DATABASE_DETAIL_TYPE.CLUSTER,
  );
  return {
    name: formatName(instanceName),
    cluster: rest,
  };
};

export const instanceDetailRequiredMap = getRequiredMap(instanceDetailSchema);
